import { render, staticRenderFns } from "./widget-password.vue?vue&type=template&id=9d3aa37c&scoped=true"
import script from "./widget-password.vue?vue&type=script&lang=js"
export * from "./widget-password.vue?vue&type=script&lang=js"
import style0 from "./widget-password.vue?vue&type=style&index=0&id=9d3aa37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3aa37c",
  null
  
)

export default component.exports